import { render, staticRenderFns } from "./BlackKits.vue?vue&type=template&id=4726a678&"
import script from "./BlackKits.vue?vue&type=script&lang=js&"
export * from "./BlackKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports